import { render, staticRenderFns } from "./scene-bar-add.vue?vue&type=template&id=25a71050"
import script from "./scene-bar-add.vue?vue&type=script&lang=js"
export * from "./scene-bar-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports